import type { FC } from 'react'
import React, { useEffect } from 'react'
import { Provider as ReduxStoreProvider, useSelector } from 'react-redux'
import { Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { HistoryRouter } from 'redux-first-history/rr6'

import '../assets/css/custom.css'
import 'react-toastify/dist/ReactToastify.css'
import SelectActiveRoleModal from '../compoments/modals/SelectActiveRoleModal'
import useModal from '../hooks/useModal'
import SocketProvider from '../layouts/SocketProvider'
import type { RootState } from '../store'
import { store, history } from '../store'
import { UserRoleEnum } from '../types'

import AuthRoutes from './router/AuthRoutes'
import DispatcherRoutes from './router/DispatcherRoutes'
import ExecutivesRoutes from './router/ExecutivesRoutes'
import TenantAdminRoutes from './router/TenantAdminRoutes'

const AppContent: FC = () => {
    const { isOpen, closeModal, openModal } = useModal()
    const { activeRole, token, user } = useSelector(
        (state: RootState) => state.auth,
    )

    useEffect(() => {
        if (token && user && !activeRole) {
            openModal('add-role')
        }
        if (activeRole && user && !user?.roles?.includes(activeRole)) {
            openModal('add-role')
        }
    }, [activeRole, user, token])

    return (
        <>
            <Routes>
                {activeRole === UserRoleEnum.DISPATCHER && (
                    <Route path="*" element={<DispatcherRoutes />} />
                )}
                {activeRole === UserRoleEnum.TENANT_ADMIN && (
                    <Route path="*" element={<TenantAdminRoutes />} />
                )}
                {activeRole === UserRoleEnum.EXECUTIVES && (
                    <Route path="*" element={<ExecutivesRoutes />} />
                )}
                <Route path="*" element={<AuthRoutes />}></Route>
            </Routes>
            <SelectActiveRoleModal
                isOpen={isOpen('add-role')}
                onClose={() => closeModal('add-role')}
            />
            <SocketProvider />
        </>
    )
}

const App: FC = () => (
    <ReduxStoreProvider store={store}>
        <HistoryRouter history={history}>
            <AppContent />
        </HistoryRouter>
        <ToastContainer />
    </ReduxStoreProvider>
)

export default App
